module.exports = "/_next/static/images/wirelessBanner-c594bc24e1527624ecd7534312f19436.webp";